import React from 'react';
import { Card, ProgressBar } from 'react-bootstrap';
import styles from './AnalyticsDashboard.module.css';

const AnalyticsDashboard = ({ stats }) => {
  const trend = stats?.registrationTrend || [];

  return (
    <Card className={styles.card}>
      <Card.Body>
        <Card.Title>Мини-аналитика</Card.Title>
        <p className="text-muted small mb-3">
          Пример визуализации тренда регистраций / активности. Можно заменить на полноценный график.
        </p>
        {trend.length === 0 && <div className="text-muted">Нет данных для отображения</div>}
        {trend.map((item) => (
          <div key={item.label} className="mb-2">
            <div className="d-flex justify-content-between small mb-1">
              <span>{item.label}</span>
              <span>{item.value}</span>
            </div>
            <ProgressBar now={item.value} max={stats?.trendMax || 100} />
          </div>
        ))}
      </Card.Body>
    </Card>
  );
};

export default AnalyticsDashboard;

